/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { IEditor } from "../../IEditor";
import { ConfigEditorEdit } from "./ConfigEditorEdit/ConfigEditorEdit";
import { ConfigEditorEditComponent } from "./ConfigEditorEdit/ConfigEditorEditComponent";
import { registerCommands } from "./Commands";
import { registerKeyBindings } from "./KeyBindings";

export function ConfigEditorModule(dc: IEditor): void {
	dc.get("logger").debug("Config Editor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView("appConfig", ConfigEditorEdit, ConfigEditorEditComponent);

	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.CONFIG, "appConfig.open");

	registerCommands(dc);
	registerKeyBindings(dc);
}
